import { render } from "./RequestSupportPage.vue?vue&type=template&id=c34d1358&ts=true"
import script from "./RequestSupportPage.vue?vue&type=script&lang=ts"
export * from "./RequestSupportPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Dashboard/Profile/RequestSupportPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c34d1358"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c34d1358', __exports__)) {
    api.reload('c34d1358', __exports__)
  }
  
  module.hot.accept("./RequestSupportPage.vue?vue&type=template&id=c34d1358&ts=true", () => {
    api.rerender('c34d1358', render)
  })

}


export default __exports__